import { Skeleton } from "../../../components/skeleton";
import { useApi } from "../../../hooks/use-api";

interface ProofOfValueSummary {
  period?: string;
}

export default function ProofOfValuePage() {
  const { data, isLoading, error } = useApi<ProofOfValueSummary>("/v1/reports/pov");

  if (isLoading) {
    return (
      <div className="mx-auto max-w-3xl p-6">
        <Skeleton className="h-80 rounded-xl" />
      </div>
    );
  }

  const mounted = !error && !!data;

  return (
    <div className="mx-auto max-w-3xl space-y-6 p-6">
      <div className="flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
        <div>
          <h1 className="text-2xl font-bold text-[var(--color-foreground)]">Proof of Value Report</h1>
          <p className="mt-2 text-sm text-[var(--color-muted-foreground)]">
            This surface now reflects the mounted runtime truth. Stero still needs a real `/v1/reports/pov` delivery contract before before/after ROI narratives, export, and share actions can be shown here.
          </p>
        </div>
        <div className="flex gap-2">
          <button
            disabled
            className="cursor-not-allowed rounded-lg border border-[var(--color-border)] px-4 py-2 text-sm text-[var(--color-muted-foreground)] opacity-70"
          >
            Export PDF
          </button>
          <button
            disabled
            className="cursor-not-allowed rounded-lg bg-[var(--color-primary)] px-4 py-2 text-sm text-[var(--color-primary-foreground)] opacity-50"
          >
            Share Link
          </button>
        </div>
      </div>

      {mounted ? (
        <div className="rounded-xl border border-[var(--color-success)]/30 bg-[var(--color-success)]/5 p-5">
          <h2 className="text-sm font-semibold text-[var(--color-success)]">Mounted contract detected</h2>
          <p className="mt-1 text-sm text-[var(--color-muted-foreground)]">
            The API returned data for period <span className="font-medium text-[var(--color-foreground)]">{data.period ?? "unknown"}</span>,
            but this page intentionally withholds a fabricated ROI layout until the final response schema is formalized.
          </p>
        </div>
      ) : (
        <div className="rounded-xl border border-[var(--color-warning)]/30 bg-[var(--color-warning)]/10 p-5">
          <h2 className="text-sm font-semibold text-[var(--color-warning)]">Report runtime not mounted yet</h2>
          <p className="mt-1 text-sm text-[var(--color-muted-foreground)]">
            The frontend no longer invents a POV report. Remaining work is the actual tenant-scoped report route plus a verified export/share contract.
          </p>
          {error && (
            <p className="mt-3 text-xs text-[var(--color-muted-foreground)]">
              Latest API error: <span className="font-medium">{error}</span>
            </p>
          )}
        </div>
      )}
    </div>
  );
}
